module.exports = __webpack_public_path__ + "assets/listcoltwo.022e09f8.svg";